<template>
    <div id="contacts">
        <div class="contact-subhead">
            Contacts
        </div>
        <div class="contact-group" v-for="contact in contacts" v-bind:key="contact.idContact">
            <div class="contact-name">
                <span v-show="contact.name">{{contact.name}}</span><span v-show="contact.name && contact.title">, </span><span v-show="contact.title">{{contact.title}}</span>
            </div>
            <div class="contact-details">
                <div v-show="contact.phone"><a v-bind:href="'tel:' + contact.phone">{{contact.phone | phoneNum}}<span v-show="contact.extension"> Ext: {{contact.extension}}</span></a></div>
                <div v-show="contact.email">{{contact.email}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Contacts",
        props: ['contacts']
    }
</script>

<style scoped>

</style>